import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useNavigate } from 'react-router';
import { db } from '../../db';
import { Icon } from '@iconify/react/dist/iconify.js';

export const Critical = ({
}): JSX.Element => {
  const navigate = useNavigate();
  const [isBusy, setIsBusy] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setIsBusy(false);
      wipe();
    }, 3000);
  }, []);

  if (isBusy)
    return contain(<>
      <div className='dotpulse-container'>
        <div className='dotpulse' />
      </div>
    </>);

  return contain(<>
    <Icon icon='heroicons:exclamation-triangle' className='w-16 h-16 text-red-600' />
    <div>An unexpected problem occurred. Please reload this webpage to try again.</div>
  </>);
}


function contain(children: React.ReactNode): JSX.Element {
  return (<div className='flex flex-col gap-2 justify-evenly items-center bg-gray-100 p-2 rounded-md min-h-[10rem]'>
    {children}
  </div>);
}

async function wipe() {
  console.warn(`Clearing image cache for ${db.cachedUser}...`);
  await Promise.all([
    db.metaWhereUser().delete(),
    db.pngWhereUser().delete(),
  ]);
  console.log('Image cache cleared');
}
